import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { FR as FR1 } from "./fr";
import { FR2 } from "./fr2";

const FR = { ...FR2, ...FR1 };

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s });

export const translate = (lang, s) => (lang === "fr" ? FR[s] ?? s : s);

let currentLang = localStorage.getItem("mb_lang") || "en";
// Non-hook translator for components that re-mount on language change (App keys the tree by lang).
export const tr = (s) => translate(currentLang, s);
export const getLang = () => currentLang;

export function LangProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(() => localStorage.getItem("mb_lang") || "en");

  currentLang = lang;

  useEffect(() => {
    if (user?.language && user.language !== lang) { currentLang = user.language; setLangState(user.language); localStorage.setItem("mb_lang", user.language); }
  }, [user?.language]); // eslint-disable-line react-hooks/exhaustive-deps

  const setLang = useCallback((next) => {
    currentLang = next;
    setLangState(next);
    localStorage.setItem("mb_lang", next);
    document.documentElement.lang = next;
    if (user) client.post("/auth/me/language", { language: next }).catch(() => {});
  }, [user]);

  const value = useMemo(() => ({ lang, setLang, t: (s) => translate(lang, s) }), [lang, setLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
